import React, { Component, Fragment } from 'react'
import { Map, List, fromJS } from 'immutable'
import { Button, Popup } from 'semantic-ui-react'
import { connectForm, ModalForm, Group, Form, Field, Submit, Columns, InfoGroup, Info } from '~/form'
import { managePerson } from '../../actions'
import Prompt from '~/common/prompt'
import moment from 'moment'

let hours = ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11']
let minutes = ['00', '05', '10', '15', '20', '25', '30', '35', '40', '45', '50', '55']
let durationOptions = []

for (let hour of hours) {
  for (let minute of minutes) {
    let value = `${hour}:${minute}`
    durationOptions.push({ value, text: value })
  }
}

class CancelInterview extends Component {
  render() {
    return (
      <Prompt
        content="Peru kuvaus"
        onAction={() => console.log('Cancel interview')}
        question="Haluatko varmasti perua kuvauksen?"
      />
    )
  }
}

class PersonConnect extends Component {
  static formSubmit(dispatch, formId, values) {
    let person = values.get('person')
    dispatch(managePerson(formId, person.get('project_id'), person.get('id'), values))
  }

  static formValidation = {
    'person.data.name': ['required'],
    'person.email': ['required', 'email'],
  }

  state = {
    hasInterview: false,
  }

  componentDidMount = () => {
    let { formInit, person, task, interviews } = this.props
    if (!List.isList(interviews)) interviews = List()

    let interview = person.get('interview_id')
      ? interviews.find(i => i.get('id') === person.get('interview_id'))
      : false

    if (!task && Map.isMap(interview))
      task = interview.get('tasks', List()).find(t => t.get('task_type_id') === 'INTERVIEW')

    if (!Map.isMap(task)) task = Map()

    this.setState({
      hasInterview: Map.isMap(interview),
    })

    formInit(Map().set('person', person).set('task', task))
  }

  render() {
    let { formUpdate, formSubmit, formState, formLoading, onClose, person, interviews, edit = false } = this.props

    let { hasInterview } = this.state

    let actions = <Button size="tiny" color="green" content="Tallenna" icon="save" />

    let { values } = formState
    let status = values.getIn(['person', 'status'])

    let interview = interviews.find(i => i.get('id') === values.getIn(['person', 'interview_id']))
    let canCreateInterviewTask = Map.isMap(interview) && !interview.has('mainTask')

    let title = edit ? 'Muokkaa kuvauksen tietoja' : 'Yhdistä henkilö haastatteluun'

    if (hasInterview) title = 'Muokkaa haastateltavan tietoja'

    return (
      <ModalForm id="manage-person" onSubmit={formSubmit} formState={formState} actions={actions} onClose={onClose}>
        <Group title={title}>
          <InfoGroup>
            <Info
              label="Luotu"
              text={moment(person.get('created_at'), 'YYYY-MM-DD HH:mm:ss.SSSZZ').format('DD.MM.YYYY - HH:mm')}
            />
            <Info
              label="Päivitetty"
              text={moment(person.get('updated_at'), 'YYYY-MM-DD HH:mm:ss.SSSZZ').format('DD.MM.YYYY - HH:mm')}
            />
          </InfoGroup>
          <Field
            placeholder="Henkilön nimi"
            type="text"
            size="large"
            name="person.data.name"
            onChange={formUpdate}
            formState={formState}
          />
          <Columns count="2">
            <Field label="Sähköposti" type="email" name="person.email" onChange={formUpdate} formState={formState} />
            <Field
              label="Puhelinnumero"
              type="text"
              name="person.data.phone"
              onChange={formUpdate}
              formState={formState}
            />
          </Columns>
          <Columns count="2">
            <Field
              label="Muistiinpanot"
              type="textarea"
              name="person.data.notes"
              onChange={formUpdate}
              formState={formState}
            />
            <Field
              label="Kieli"
              type="radios"
              name="person.lang"
              options={[
                { value: 'fi', label: 'Suomi' },
                { value: 'en', label: 'Englanti' },
                { value: 'se', label: 'Ruotsi' },
              ]}
              onChange={formUpdate}
              formState={formState}
            />
          </Columns>
          {!hasInterview ? (
            <Field
              label="Henkilön status"
              type="select"
              name="person.status"
              options={[
                { text: 'Odottaa käsittelyä', value: 'pending' },
                { text: 'Soita myöhemmin uudestaan', value: 'callback' },
                { text: 'Tulee mukaan', value: 'accepted' },
                { text: 'Kieltäytyy', value: 'declined' },
              ]}
              onChange={formUpdate}
              formState={formState}
            />
          ) : null}
        </Group>
        {status === 'accepted' ? (
          <Fragment>
            {!hasInterview && List.isList(interviews) ? (
              <Group title="Kohdista haastatteluun">
                <Field
                  label="Haastattelu"
                  type="select"
                  name="person.interview_id"
                  options={interviews
                    .map(i => ({ value: i.get('id'), text: `${i.get('name')} (${i.get('people', List()).size})` }))
                    .unshift({ value: null, text: 'Ei haastattelua' })
                    .toArray()}
                  onChange={formUpdate}
                  formState={formState}
                />
              </Group>
            ) : null}
            {canCreateInterviewTask ? (
              <Group>
                <Field
                  inputLabel="Luo kuvaustaski"
                  type="checkbox"
                  name="create_task"
                  onChange={formUpdate}
                  formState={formState}
                />
              </Group>
            ) : null}
            {canCreateInterviewTask && values.get('create_task') === true ? (
              <Group title="Kuvauksen tiedot">
                <Columns count="2">
                  <Field
                    label="Kuvausaika"
                    type="datetime"
                    name="task.deadline"
                    onChange={formUpdate}
                    formState={formState}
                  />
                  <Columns count="2">
                    <Field
                      label="Kesto"
                      type="select"
                      name="task.data.duration"
                      options={durationOptions}
                      onChange={formUpdate}
                      formState={formState}
                    />
                    <Field
                      label="Kalenterisynkkaus"
                      inputLabel="Päivitä kalenteria"
                      type="checkbox"
                      name="task.data.enableCalendarSync"
                      onChange={formUpdate}
                      formState={formState}
                    />
                  </Columns>
                </Columns>
                <Field
                  label="Osoite"
                  type="map"
                  name="task.data.coordinates"
                  onChange={formUpdate}
                  formState={formState}
                />
                <Field
                  label="Huomiot kuvaukseen"
                  type="textarea"
                  name="task.data.notes"
                  onChange={formUpdate}
                  formState={formState}
                />
                <Field
                  label="Kuvaaja"
                  type="reference"
                  referenceConfig={{ id: 'taskUser', options: { source: 'user' } }}
                  name="task.user_id"
                  onChange={formUpdate}
                  formState={formState}
                />
              </Group>
            ) : null}
          </Fragment>
        ) : null}
      </ModalForm>
    )
  }
}

export default connectForm('person-connect', PersonConnect, state => ({}))
